import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'
import { useEffect, useState } from 'react';
import { DOMAIN } from '../../config';
import { getRandom } from '../../funcs';
import { ImageListItemBar, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import SearchID from '../appDialog/searchID';

const CustomImageListItemBar = styled(ImageListItemBar)({
  fontSize: '1rem', 
  typography: 'subtitle1'
});

export default function RightBarImgList({matches}){
    const [couples, setCouples] = useState(null)
    const [openSearch, setOpenSearch] = useState(false)
    const [chipTitle, setChipTitle] = useState(null)
    
    const handleOpenSearch = (caption)=>{
      setChipTitle(caption)
      setOpenSearch(true)
    }
    
    useEffect(()=>{
      fetch(`${DOMAIN}ywyminiappbot/getCouplesRightbar`)
          .then((response)=>response.json())
          .then((data)=>{
            if(data.length == 0) return
            setCouples(data)
        })
    },[])

    return(
      <Box>
        <SearchID
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
                chipTitle={chipTitle}
        />
        <ImageList cols={3} rowHeight={100} gap={2}>
          {couples&&couples.map((item) => (
            <ImageListItem key={item.img+getRandom()}>
              <img
                srcSet={`${DOMAIN}miniapp/${item.medias[1].fileid}.tb.jpg?fit=crop&auto=format&dpr=2 2x`}
                src={`${DOMAIN}miniapp/${item.medias[1].fileid}.tb.jpg?fit=crop&auto=format&dpr=2 2x`}
                alt="图片"
                loading="lazy"
                onClick={()=>{
                  handleOpenSearch(item.id)
                }}
                style={{
                  borderRadius:"5px",
                  overflow:"hidden"
              }}
              />
              <CustomImageListItemBar
                style={{
                  fontSize:"12px",
                  padding:0
                  
                }}
                subtitle={<Typography sx={{ fontSize: '0.7rem' }}>
                {item.caption} {/* 只显示20个字符 */}
              </Typography>}
                
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      
    )
}
